<template>
  <page-option :disable-add="!checkAccess('user.create')" overflow-hidden>
    <template #title>
      <v-avatar color="#E3FCF7" size="35">
        <v-icon color="#108F6E" size>mdi-account</v-icon>
      </v-avatar>
      <div class="pl-2 title-page">
        {{ option.title || $t('sidebar.users.name') }}</div
      >
    </template>
    <template #below-toolbar>
      <FilterSearch
        v-model="params"
        can-show-in-search
        :disableCreate="!checkAccess('user.create')"
        placeholder="Tìm kiếm theo tên hoặc số điện thoại"
        @click:create="onCreateItem()"
      >
        <div class="d-flex flex-sm-row flex-column flex-warp">
          <div class="filter-item">
            <field-group
              v-model="params.inactive"
              background-color="#FFFFFF"
              dense
              :items="status.items"
              :label="$t('active-title.title')"
              :loading="status.loading"
              no-label
              outlined
              typeInput="v-select"
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.role_id"
              background-color="#FFFFFF"
              clearable
              dense
              item-text="name"
              item-value="id"
              :items="roles.items"
              label="Quyền"
              :loading="roles.loading"
              no-label
              outlined
              typeInput="v-select"
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.date_start"
              background-color="#FFFFFF"
              clearable
              dense
              label="Ngày bắt đầu"
              no-label
              outlined
              type-input="field-date"
            >
            </field-group>
          </div>
          <div class="filter-item">
            <field-group
              v-model="params.date_end"
              background-color="#FFFFFF"
              clearable
              dense
              label="Ngày kết thúc"
              no-label
              outlined
              type-input="field-date"
            >
            </field-group>
          </div>
        </div>
      </FilterSearch>
    </template>
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
      >
        <template v-slot:no-data>
          <p class="ma-0">Không có kết quả nào</p>
        </template>
        <template v-slot:[`item.username`]="{ item }" :title="item.username">
          <div class="text-width text-truncate d-inline-block">{{
            item.username
          }}</div>
        </template>
        <template v-slot:[`item.inactive`]="{ value, item }">
          <div>
            <div
              v-if="currentId != item.id"
              @click.stop="toggleblockUser(item)"
            >
              <v-switch
                color="primary"
                dense
                disabled
                :false-value="true"
                flat
                :input-value="value"
                small
                :true-value="false"
              ></v-switch>
            </div>
          </div>
        </template>
        <template v-slot:[`item.roles`]="{ item }">
          <v-chip
            v-for="role in item.roles"
            :key="role.id"
            :color="role.meta.color"
            :text-color="role.meta['text-color']"
            class="py-1 px-2 text-caption ma-1 font-weight-bold"
            label
          >
            {{ role.name }}
          </v-chip>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span>
            {{ item.created_at | dateTime('short') }}
          </span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
          ></base-button-group>
        </template>
      </base-serve-table>
    </v-sheet>
    <UserDialog
      ref="dialog"
      :option="option"
      :roles="roles"
      @reset="onReset()"
    />
    <ResetPasswordDialog ref="resetdialog" />
  </page-option>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import { API_ROLE, API_USER } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import UserDialog from './user-dialog.vue'
import { EDIT_TYPE } from '@constant'
import ResetPasswordDialog from './reset-password-dialog.vue'
export default {
  mixins: [],
  components: {
    UserDialog,
    FilterSearch,
    ResetPasswordDialog,
  },
  props: { option: { type: Object, default: () => ({ params: {} }) } },
  data: (vm) => ({
    default_params: { with: 'roles,createdBy' },
    params: { search: '', inactive: null },
    menus: [
      {
        title: 'Đặt lại mật khẩu',
        icon: 'mdi-lock-reset',
        handler: (item) => vm.onResetPassword(item),
        disabled: (item) => !vm.checkAccess('user.update', item),
      },
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('user.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('user.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Tên đăng nhập',
        align: 'start',
        sortable: true,
        value: 'username',
      },
      {
        text: 'Số điện thoại',
        align: 'start',
        sortable: false,
        value: 'mobile',
      },
      {
        text: 'Trạng thái',
        align: 'start',
        sortable: true,
        value: 'inactive',
      },
      {
        text: 'Quyền',
        align: 'start',
        value: 'roles',
        sortable: false,
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
    status: {
      loading: false,
      items: [
        { text: 'Toàn bộ', value: null },
        { text: 'Hoạt động', value: false },
        { text: 'Vô hiệu', value: true },
      ],
    },
    roles: {
      loading: false,
      items: [],
    },
  }),
  watch: {},
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_USER
    },
  },
  created() {
    this.roles.loading = true
    API_ROLE.list()
      .then((res) => {
        this.roles.items = res.data
      })
      .finally(() => {
        this.roles.loading = false
      })
  },
  mounted() {},
  methods: {
    onResetPassword(item) {
      this.$refs.resetdialog.open(item)
    },
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await API_USER.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
        }
        return result
      }
    },
    onCreateItem() {
      this.$refs.dialog.open({}, EDIT_TYPE.CREATE)
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
    onReset() {
      this.$refs.table.reload()
    },
    async toggleblockUser(item) {
      const { inactive, id, username } = item
      const typeAction = inactive ? 'unblock' : 'block'
      let confirm = new ConfirmBuilder()
      confirm
        .setTitle('actions.' + typeAction)
        .addMessage('confirm.' + typeAction)
        .setOption({
          params: {
            id,
            inactive,
            username,
            name: username,
          },
          color: 'error',
        })
      if (await confirm.confirm()) {
        const res = await API_USER.getSdk().put(
          `/users/${id}/${!inactive ? `inactive` : 'active'}`
        )
        if (res && res.status == 200) item.inactive = !item.inactive
      }
    },
  },
}
</script>
